import { motion } from "framer-motion";
import { ArrowRight, BadgeCheck } from "lucide-react";

export default function Products({ products, onQuote }) {
  return (
    <section id="products" className="max-w-7xl mx-auto px-6 py-20 lg:py-28" data-testid="products-section">
      <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A1F]" data-testid="products-eyebrow">Product Catalogue</p>
      <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="products-heading">
        Wholesale ranges, made to your brand
      </h2>
      <p className="mt-4 max-w-2xl text-base md:text-lg text-slate-400 leading-relaxed">
        Every range is fully customisable — fabrics, colours, prints, labels and packaging. Pick a range and request a trade quote.
      </p>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((p, i) => (
          <motion.article key={p.id}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.08 }}
            className="group bg-[#161B22] border border-white/10 rounded-2xl overflow-hidden hover:border-[#FF5A1F]/40 transition-colors"
            data-testid={`product-card-${p.id}`}>
            <div className="h-56 overflow-hidden">
              <img src={p.image} alt={p.name} loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-heading text-xl font-bold">{p.name}</h3>
                <span className="shrink-0 text-xs font-bold text-[#FF5A1F] uppercase tracking-wider bg-[#FF5A1F]/10 rounded-full px-3 py-1">{p.moq}</span>
              </div>
              <p className="mt-1 text-sm text-slate-400">{p.tagline}</p>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">{p.description}</p>
              <ul className="mt-4 space-y-1.5">
                {p.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-slate-300">
                    <BadgeCheck size={14} className="text-[#10B981] shrink-0" /> {f}
                  </li>
                ))}
              </ul>
              <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
                <a href={`/products/${p.id}`} data-testid={`product-view-link-${p.id}`}
                  className="inline-flex items-center gap-2 text-sm font-bold text-white border border-white/20 rounded-full px-4 py-2 hover:bg-white/10 transition-colors">
                  View Range
                </a>
                <button data-testid={`product-quote-button-${p.id}`} onClick={() => onQuote(p.id)}
                  className="inline-flex items-center gap-2 text-sm font-bold text-[#FF5A1F] hover:gap-3 transition-all">
                  Get Bulk Quote <ArrowRight size={16} />
                </button>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
